<mat-toolbar class="toolbar-example">
    <span>Room Creation</span>
    <span class="fill-remaining-space"></span>
    <mat-icon style="cursor: pointer;" (click)='onClose()'>close</mat-icon>
</mat-toolbar>

<h2 style="text-align: center;">Enter Room Details</h2>
<p style="padding-left: 28px;">Note : * are mandatory</p>


<form [formGroup]="panelService.form" class="form-content-display" (submit)='onSubmitPanelCreation(processId)'>
  <mat-form-field>
    <input formControlName="panelName" matInput placeholder="Room Name" required>
    <mat-error *ngIf="panelService.form.controls['panelName'].errors?.required">Room Name cannot be empty, minimum 1 Character needed.
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <input formControlName="roomIdentification" matInput placeholder="Room Identification" required>
    <mat-error *ngIf="panelService.form.controls['roomIdentification'].errors?.required">Room Identification
      cannot be empty, minimum 1 Character needed.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input formControlName="meetingLink" matInput placeholder="Meeting Link">
    <mat-icon
      title="Add MOVIE Meeting Link"
      style="cursor: pointer; vertical-align: bottom; font-size: 20px; color: #252c61;"
      matSuffix
      *ngIf="!panelService.form.controls['meetingLink'].value"
      (click)="fetchMeetingLink('MOVIE')">
      add_circle
    </mat-icon>

    <mat-icon
      title="Remove Meeting Link"
      style="cursor: pointer; vertical-align: bottom; font-size: 20px; color: #252c61;"
      matSuffix
      *ngIf="panelService.form.controls['meetingLink'].value"
      (click)="clearMeetingLink()">
      remove_circle
    </mat-icon>
    <mat-error *ngIf="panelService.form.controls['meetingLink'].errors?.pattern">
      Invalid meeting link
    </mat-error>
    <!-- <mat-error *ngIf="panelService.form.controls['roomIdentification'].errors?.required">Room Identification
      cannot be empty, minimum 1 Character needed.</mat-error> -->
  </mat-form-field>

  <mat-form-field>
    <input formControlName="panelMembers" matInput placeholder="Choose Panel Members" required>
    <button type="button" mat-button matSuffix mat-icon-button
      (click)="panelMemberListModal(processId, panelId)">
      <mat-icon style="color: #252c61;">contacts</mat-icon>
    </button>
    <mat-error *ngIf="panelService.form.controls['panelMembers'].errors?.required">Panel Member
      cannot be empty, minimum 1 panel member needed.</mat-error>
  </mat-form-field>

  <mat-form-field>
    <input formControlName="candidates" matInput placeholder="Choose Candidates" required>
    <button type="button" mat-button matSuffix mat-icon-button (click)="candidateListModal(processId, panelId)">
      <mat-icon style="color: #252c61;">contacts</mat-icon>
    </button>
    <mat-error *ngIf="panelService.form.controls['candidates'].errors?.required">Candidates
      cannot be empty, minimum 1 candidate needed.</mat-error>
  </mat-form-field>
<br>
  <div class="actions-example">
    <button mat-flat-button class="btn-cancel" (click)="clearPanelForm()">Cancel</button>
    <button mat-flat-button style="margin-left: 10px;" class="btn-color-example" type="submit" [disabled]="panelService.form.invalid">{{panelButton}}</button>
  </div>
</form>


<!-- <div class="panel-form-box mat-elevation-z4">
    <mat-card-title>
      {{process.processName}}
    </mat-card-title>
    <form [formGroup]="panelService.form" class="panel-form" (submit)='onSubmitPanelCreation(process.processId)'>
      <mat-card-title>Enter Panel Details</mat-card-title>

      <mat-form-field>
        <input formControlName="panelName" matInput placeholder="Panel Name" required>
        <mat-error *ngIf="panelService.form.controls['panelName'].errors?.required">Panel Name cannot be null, minimum 1 Charachter needed.
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <input formControlName="roomIdentification" matInput placeholder="Room Identification" required>
        <mat-error *ngIf="panelService.form.controls['roomIdentification'].errors?.required">Room Identification
          cannot be null, minimum 1 Charachter needed.</mat-error>
      </mat-form-field>

      <mat-form-field>
        <input formControlName="panelMembers" matInput placeholder="Choose Panel Members" required>
        <button type="button" mat-button matSuffix mat-icon-button
          (click)="panelMemberListModal(process.processId)">
          <mat-icon>contacts</mat-icon>
        </button>
        <mat-error *ngIf="panelService.form.controls['panelMembers'].errors?.required">Panel Member
          cannot be null, minimum 1 panel member needed.</mat-error>
      </mat-form-field>

      <mat-form-field>
        <input formControlName="candidates" matInput placeholder="Choose Candidates">
        <button type="button" mat-button matSuffix mat-icon-button (click)="candidateListModal(process.processId)">
          <mat-icon>contacts</mat-icon>
        </button>
      </mat-form-field>

      <div class="button-row">
        <button mat-flat-button color="warn" (click)="clearPanelForm()">Clear</button>
        <button mat-flat-button color="primary" type="submit" [disabled]="panelService.form.invalid">{{panelButton}}</button>
      </div>
    </form>
  </div> -->
